export default "__VITE_ASSET__B$Xkpdy5__"